declare var angular: any;
import * as moment from 'moment';

import * as _ from 'underscore';

angular.module('UserExamControllers')

  .directive('cfButtonToeic', function() {
    return {
      restrict: 'E',
      template: '<md-button href="#!/toeic/on">{{ user.exam ? "Reprendre toeic" : "Commencer un toeic" }}</md-button>'
    };
  })

  .directive('cfAutoplay', function() {
    return {
      scope: {
        'autoplay': '='
      },
      restrict: 'E',
      templateUrl: '/ng1/www/modules/user/practice/exam/html/autoplay.html',
      controller: ["$scope", "$mdToast", "exam", function autoplayController($scope, $mdToast, exam) {
        $scope.exam = exam;

        $scope.onChange = function() {
          var msg = ($scope.autoplay) ? "Lorsque vous répondrez, les questions suivantes seront automatiquement chargées" : "Vous devrez cliquer pour passer aux questions suivantes";
          $mdToast.show($mdToast.simple().textContent(msg));
        };

      }]
    };
  })


  /* Supports give collection of objects */

  /*
  audio: "http://localhost:8000/media/toeic/exam/audio/1.mp3"
  exam: 1
  id: 1
  image: "http://localhost:8000/media/toeic/exam/image/1_3.jpg"
  nbGoodAnswer: 0
  part: 1
  questions: Array[1]
  showHelp: true
  text: ""
  */

  .directive('cfExamCorrection', function() {
    return {
      restrict: 'E',
      scope: {
        'supports': '=',
        'part': '=',
        'main': '=',
        'userAnswersInput': '=',
        'checkRightOnCorrection': '=',
        'rawUserAnswersByQuestionId': '=',
      },
      templateUrl: '/ng1/www/modules/user/practice/exam/html/exam_correction.html',
      controller: ["$scope", 'exam', function($scope, exam) {
        $scope.hasRightOnCorrection = true;
        console.log('hasRightOnCorrection', $scope.checkRightOnCorrection);
        $scope.examData = exam.examData;
        $scope.finished = true;
        $scope.exam = true;
        $scope.correction = true;

        init();
        function init() {
          if ($scope.checkRightOnCorrection) {
            $scope.hasRightOnCorrection = ($scope.main.me.isPremium);
          }
        }

        $scope.toggleSupport = function(support) {

          if (support.show) {
            support.show = false;
          } else {
            support.show = true;
          }
        };

      }]
    };
  })


  .directive('cfSupportSubmit', function() {
    return {
      restrict: 'E',
      template: '<div ng-if="finished && training" class="md-padding">\
                <md-divider></md-divider>\
                <md-button ng-if="!supportId" ng-click="init()" class="md-accent">Suivant</md-button>\
                <md-button ng-if="supportId" ng-href="#!cours/{{lesson}}" class="md-accent">Retour au cours</md-button>\
              </div>'
    };
  })


  .directive('cfShowMock', function() {
    return {
      restrict: 'E',
      templateUrl: '/ng1/www/modules/user/practice/exam/html/show_mock.html',
    };
  })

  .directive('resize', ["$window", function($window) {
    return function(scope, element) {
      var w = angular.element($window);
      var header = angular.element(document.querySelector('header.app'))[0];
      var toolbar = angular.element(document.querySelector('#toolbar-exam'))[0];


      scope.getWindowDimensions = function() {
        return {
          'h': $window.innerHeight,
        };
      };
      scope.$watch(scope.getWindowDimensions, function(newValue, oldValue) {
        scope.windowHeight = newValue.h;
        scope.windowWidth = newValue.w;

        scope.style = function() {
          var heightHeader = header.offsetHeight;
          var heightToolbar = toolbar.offsetHeight;
          return {
            // size og the tooblar
            'height': (newValue.h - (heightHeader + heightToolbar)) + 'px',
          };
        };

      }, true);

      w.bind('resize', function() {
        scope.$apply();
      });
    };
  }])

  .directive('resizeOverlay', ["$window", function($window) {
    return function(scope, element) {
      var p = angular.element(document.getElementsByClassName("toeic-container-questions")[0])[0];
      scope.getHeight = function() {
        return p.scrollHeight;
      };
      scope.$watch(scope.getHeight, function(newValue, oldValue) {
        scope.overlayStyle = function() {
          return {
            // size og the tooblar
            'height': Math.max(newValue, element[0].parentElement.clientHeight) + 'px',
          };
        };

      }, true);

      angular.element($window).bind('resize', function() {
        scope.$apply();
      });
    };
  }])

  .directive('cfHistoricGraphToeic', function() {
    return {
      restrict: 'E',

      scope: {
        toeics: '=',
      },

      controller: ["$scope", "$http", "exam", function($scope, $http, exam) {

        var refresh = function() {

          var toeicsReverse = JSON.parse(JSON.stringify($scope.toeics)).reverse();

          var x = {};
          var score = [];

          $scope.barData = {
            labels: [],
            series: []
          };

          $scope.barOptions = _.extend({
            low: 0,
            high: exam.examData.score.max,
            showArea: true,
          }, exam.examData.mock.graphOptions);

          console.log($scope.barOptions)

          for (var i = 0; i < toeicsReverse.length; i++) {
            let h = toeicsReverse[i];
            score.push(h.score);
            $scope.barData['labels'].push(h.created_at);
          }


          $scope.barData['series'][0] = score;
        };

        $scope.$watch(function() {
          return $scope.toeics.length;
        }, function(newVal, oldVal) {
          refresh();
        }, true);

      }],
      templateUrl: '/ng1/www/modules/user/practice/exam/html/historic_chart.html'
    };
  })


  .directive('cfLessonShortcut', function() {
    return {
      restrict: 'E',

      scope: {
        text: '=',
      },

      controller: ["$scope", function($scope) {
        console.log($scope.text);
      }],

      template: '<div class="finished shortcut grey-bg" marked="text" layout-padding></div>'
    };
  })

  .directive('cfCorrection', function() {
    return {
      restrict: 'E',
      template: '\
    <div ng-if="finished && (question.correction || (question.lessons && question.lessons.length))" class="show-warning md-padding md-margin">\
      <p finished="true" ng-if="question.correction" class="cgs" ng-bind-html="question.correction"></p>\
      <md-button ng-repeat="lesson in question.lessons" ng-click="showLesson(lesson.id, $event)" class="text-wrap md-primary" ng-bind-html="lesson.title"></md-button>\
    </div>',
      controller: ["$scope", "lesson", function($scope, lesson) {
        $scope.showLesson = function(id, ev) {
          console.log(id);
          lesson.dialogDetail(id, ev);
        };
      }]
    };
  })


  .directive('cfScoreHistoric', function() {
    return {
      restrict: 'E',
      scope: {
        historic: '=',
      },
      template: '<canvas ng-if="!empty" class="chart chart-line" chart-options="options" chart-data="data" chart-labels="labels" chart-series="series"></canvas>',
      controller: ["$scope", "exam", function($scope, exam) {

        var historics = _.sortBy($scope.historic, (historic) => moment.utc((historic as any).created_at)).slice(-45);
        var labels = [];
        var data = [];
        for (var i = 0; (i < historics.length); i++) {
          if ((i % 4 === 0) || historics.length < 9) {
              var date = moment(((historics[i] as any).created_at)).format('L');
              labels.push(date);
          } else {
            labels.push('');
          }

          data.push((historics[i] as any).score);
        }

        $scope.labels = labels;
        $scope.data = [data];
        $scope.options = _.extend({
          "pointHitDetectionRadius": 4,
          "scaleOverride": true,
          "scaleStartValue": 0
        }, exam.examData.scoreHistoricChart.options);

        $scope.series = ['Ma progression'];

        $scope.empty = false;
      }]
    };
  })

  .directive('cfPlayerAudio', function() {
    return {
      restrict: 'E',
      scope: {
        file: '=',
        songId: '=',
        audioscript: '=',
        canPlay: '=',
        canShowAudioScript: '=',
        mode: '=', // playlist || single
        nbOfMaxRepeat: '=',
      },
      templateUrl: '/ng1/www/modules/user/practice/exam/html/player_audio.html',
      controller: ["$scope", "$timeout", "$filter", "audio", "angularPlayer", "EXAM", function($scope, $timeout, $filter, audio, angularPlayer, EXAM) {
        $scope.EXAM = EXAM;

        $scope.nbOfMaxRepeat;
        $scope.nbOfSongRepeat;

        $scope.progress = 0;

        var volume = audio.getVolume();
        $scope.musicVolume2 = volume;

        $scope.setVolume = function(value) {
          audio.setVolume(value);
        };

        // different event for training and exam
        if ($scope.mode === 'playlist') {
          var updateProgress = function() {
            for (var i = 0; i < playlist.length; i++) {
              if (playlist[i].id == $scope.currentTrackId) {
                $scope.currentTrackNumber = i + 1;
              }
            }
            $scope.progress = ($scope.currentTrackNumber / $scope.playlistLength) * 100;
          };


          var playlist = audio.getPlaylist();
          $scope.playlistLength = playlist.length;

          $scope.$on('player:playlist', function(event, data) {
            $timeout(function() {
              $scope.$apply(function() {
                var playlist = data;
                $scope.playlistLength = playlist.length;
              });
            });
          });

          $scope.$on('track:id', function(event, data) {
            $timeout(function() {
              $scope.$apply(function() {
                $scope.currentTrackId = data;
                updateProgress();
              });
            });
          });

          updateProgress();

        }

        if ($scope.mode === 'single') {
          $scope.$on('currentTrack:position', function(event, data) {
            $timeout(function() {
              $scope.$apply(function() {
                $scope.currentPostion = $filter('humanTime')(data);
              });
            });

          });

          $scope.$on('currentTrack:duration', function(event, data) {
            $timeout(function() {
              $scope.$apply(function() {
                $scope.currentDuration = $filter('humanTime')(data);
              });
            });
          });

          $scope.progress = 0;
          $scope.$on('track:progress', function(event, data) {
            $timeout(function() {
              $scope.$apply(function() {
                $scope.progress = data;
                if (data === 100) {
                  $scope.nbOfSongRepeat++;
                }
              });
            });
          });

          $scope.$on('track:loaded', function(event, data) {
            $timeout(function() {
              $scope.$apply(function() {
                $scope.loaded = data;

                $scope.nbOfSongRepeat = 0;
              });
            });
          });
        }



        $scope.$on('music:isPlaying', function(event, data) {
          $scope.isPlaying = !!data;
        });

        $scope.$on('track:id', function(event, data) {
          $timeout(function() {
            $scope.$apply(function() {
              $scope.currentTrackId = data;
            });
          });
        });


        $scope.togglePlay = function() {
          if (angularPlayer.isPlayingStatus()) {
            angularPlayer.pause();
          } else {
            angularPlayer.play();
          }
        }

        $scope.playTheAudio = function(supportId) {
          if (angularPlayer.isPlayingStatus()) {
            angularPlayer.pause();
          }

          if ($scope.file) {
            console.log($scope.file, $scope.songId);
            var song = audio.convertToTrack($scope.songId, $scope.file);
            console.log('song', song);
            audio.loadOneTrack(song, true);
          }
        }


      }]
    };
  })

  .directive('cfAutoplayHelp', function(){
    return {
      restrict: "E",
      scope: {
        "autoplay": "="
      },
      template: `<div class="grey-bg md-padding">
                  <p ng-if="autoplay" ng-bind-html="activate">
                  </p>
                  <p ng-if="!autoplay">
                    <b>{{deactivate}}</b> : vous devez cliquer pour passer aux questions suivantes.
                  </p>
                </div>`,
      controller: ["$scope", 'exam', 'EXAM', function ($scope, exam, EXAM) {
        if (exam.examData.langForExercises === 'fr') {
          $scope.activate =  "<b>Lecture automatique activée</b>";
          $scope.deactivate =  "Lecture automatique désactivée";
        } else {
          $scope.activate = "Autoplay activé"
          $scope.deactivate = "Autoplay désactivé"
        }

        if (EXAM === 'lerobert') {
          $scope.activate =  $scope.activate + " : après avoir répondu à une question, la suivante se charge automatiquement.";
        } else {
          $scope.activate =  $scope.activate + " : lorsque vous répondez les questions suivantes seront automatiquement chargées."
        }
      }]
    }
  })


  .directive('cfProgressExam', function() {
    return {
      restrict: "E",
      template: '<div ng-if="total" layout="column" layout-align="center center">'+
        '<md-progress-circular ng-if="ratio !== 100" md-mode="determinate" value="{{ratio}}"></md-progress-circular>'+
        '<md-icon ng-if="ratio === 100" md-svg-icon="check" class="text-success s48"></md-icon>'+
        '<p class="md-subhead">{{::title}}</p>'+
        '</div>',
      scope: {
        title:"@",
        index:"=",
        total:"="
      },
      controller: ["$scope", function ($scope) {
        $scope.$watch(function() {
          return ($scope.index || $scope.total);
        }, function() {
          if ($scope.index && $scope.total)
            $scope.ratio = Math.round((($scope.index + 1) / $scope.total) * 100);
        }, true);
      }]
    };
  });
